<template>
  <BasePage :pageTitle="__DICT__.menuOptions.Workshops" show-menu show-footer>
    <div v-for="group in filteredGroups" :key="group" class="card mb-2">
      <router-link :to="`/workshop/${getLessonsForGroup(group)[0].reference.split('-')[2]}`">
        <div class="card-header">
          <div class="card-status-top bg-primary"></div>
          <h4 class="card-title">{{ group }}</h4>
          <div class="card-actions">
            <span class="badge bg-primary text-white">{{ getLessonsForGroup(group).length }} {{
                __DICT__.participants
              }}</span>
          </div>
        </div>
      </router-link>
    </div>

    <div v-if="isRecovering" class="text-center mt-3">
      <div class="spinner-border text-primary" role="status"></div>
      <span class="ms-2">{{ __DICT__.loading }}</span>
    </div>
  </BasePage>
</template>

<script setup>
import {ref, computed} from 'vue'
import BasePage from "@/components/BasePage.vue"
import {useEnsureWeekData} from "@/composables/useEnsureWeekData.js";

// weekData follows the store, so workshops appear once background recovery
// refills it; it is null until then.
const {weekData, isRecovering} = useEnsureWeekData()
const selectedGroup = ref('all')

const groupLessons = computed(() => {
  const groups = {}
  const data = weekData.value || []
  data.forEach(passenger => {
    const lesson = passenger.allocPlaces?.find(place => place.lessons)?.lessons
    if (lesson) {
      if (lesson.lessonType === "workshops") {
        if (!groups[lesson.group]) {
          groups[lesson.group] = new Set()
        }
        groups[lesson.group].add(JSON.stringify(lesson))
      }
    }
  })

  // Convert sets of stringified lessons back to arrays of objects
  return Object.fromEntries(
      Object.entries(groups).map(([group, lessonsSet]) => [
        group,
        Array.from(lessonsSet).map(lessonStr => JSON.parse(lessonStr))
      ])
  )
})

const groups = computed(() => {
  return Object.keys(groupLessons.value).sort((a, b) => {
    // Extract numbers from the group names for sorting
    const aMatch = a.match(/\d+/)
    const bMatch = b.match(/\d+/)
    const aNum = aMatch ? parseInt(aMatch[0]) : 0
    const bNum = bMatch ? parseInt(bMatch[0]) : 0
    return aNum - bNum
  })
})

const filteredGroups = computed(() =>
    selectedGroup.value === 'all' ? groups.value : [selectedGroup.value]
)

function getLessonsForGroup(groupName) {
  return groupLessons.value[groupName].sort((a, b) => {
    // Sort by times if available, otherwise by reference
    if (a.times && b.times) {
      return a.times.localeCompare(b.times)
    }
    return a.reference.localeCompare(b.reference)
  })
}
</script>